import { useMutation, useQueryClient } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';
import toaster from 'utils/toaster';

export interface ISaveScheduleSettings {
  manage_schedule_shift: boolean;
  allow_schedule_overlapping: boolean;
  show_employees_sched_assigned_users: boolean;
  requires_schedule_to_clock_in: boolean;
  requires_schedule_to_clock_within_period: number;
}

const saveScheduleSettings = (postData: ISaveScheduleSettings) => {
  return http().post(endpoints.companySettings.scheduleSettings, postData);
};

export function useSaveScheduleSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: saveScheduleSettings,
    onSuccess: (data: any) => {
      queryClient.invalidateQueries({ queryKey: ['fetchUserDetails'] });

      if (data.message) {
        toaster.success({ description: data.message });
      }
    },
  });
}
